// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent !important;
}

ion-grid {
  --background: transparent !important;
}

.ask-customer-rotate-component-container {
  margin: 2px;
  padding: 2px 10px 3px 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 50px;
}

.ask-customer-rotate-close-button-container {
  transform: translate(calc(var(--ask-customer-rotate-popover-width) / 2 + 50px), 4px);
  width: 38px;
  background: rgb(4, 19, 55) !important;
  border-radius: 10px 10px 0px 0px;
  border-width: 2px 2px 0 2px;
  box-shadow: 0px -3px 3px 3px rgb(10, 3, 163);
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
}

.ask-customer-rotate-close-button {
  cursor: pointer;
  background: radial-gradient(circle at 50% 120%, #f20606, #e60404 10%, #7b0404 80%, #4c0202 100%);
  height: 22px;
  width: 22px;
  border-radius: 11px;
  box-shadow: 0 0px 5px 2px #ffffff, 0 0px 5px 6px rgb(10, 3, 163);
  display: flex;
  justify-content: center;
  align-items: center;
}
.ask-customer-rotate-close-button ion-icon {
  text-shadow: 0 0px 5px rgb(0, 0, 0);
  z-index: 3;
  font-size: 0.8rem;
}

.sound-switch {
  display: flex;
  justify-content: center;
  margin: 5px 0;
}

ion-button[size*=medium] {
  --border-radius: 7px;
  height: 30px;
  font-size: 14px;
  width: 155px;
}

h3.description-text {
  font-family: "Mulish";
  font-size: 20px;
  color: white;
  margin: 5px 0 0 0;
  text-shadow: 2px 0px 0 #0d2e67, -2px 0px 0 #0d2e67, 0px 2px 0 #0d2e67, 0px -2px 0 #0d2e67;
  padding-left: 60px;
  padding-right: 60px;
}
h3.description-text span {
  color: white;
  text-shadow: none;
}

a.ask-customer-rotate-links {
  cursor: pointer;
  color: #86d2f0;
  font-size: 9px;
  font-weight: bold;
  text-decoration: underline;
  text-shadow: 1px 0 0 #000;
  text-underline-offset: 3px;
  text-decoration-color: #508be3;
}

a.ask-customer-rotate-link-large {
  font-size: 11px;
}

p.ask-customer-rotate-version-text {
  position: absolute;
  bottom: 20px;
  right: 8px;
  left: unset;
  text-orientation: mixed;
  writing-mode: vertical-lr;
  margin: 2px;
  color: white;
  font-size: 9px;
  letter-spacing: 1px;
}

.ask-customer-rotate-spacer {
  margin-top: 5px;
}

.rotate-picture {
  width: 60%;
  margin-bottom: 20px;
  margin-top: 20px;
}

.ask-rotate-checkbox {
  outline: 1px solid white;
}

.ask-customer-rotate-text {
  color: white;
}

.ask-customer-rotate-checkbox-area {
  padding-left: 60px !important;
}

.ask-customer-rotate-a-link {
  color: white;
  text-decoration: underline;
}

.right-bottom {
  position: absolute;
  bottom: 0;
  right: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ask-customer-rotate/ask-customer-rotate.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EAEE,WAAA;EACA,0BAAA;EAIA,iBAAA;EACA,oBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,oFAAA;EACA,WAAA;EACA,qCAAA;EACA,gCAAA;EAEA,2BAAA;EACA,4CAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AANF;;AASA;EACE,eAAA;EACA,gGAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gEAAA;EAGA,aAAA;EACA,uBAAA;EACA,mBAAA;AARF;AAUE;EACE,mCAAA;EACA,UAAA;EACA,iBAAA;AARJ;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AATF;;AAYA;EACE,oBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AATF;;AAYA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yFAAA;EAIA,kBAAA;EACA,mBAAA;AAZF;AAcE;EACE,YAAA;EACA,iBAAA;AAZJ;;AAgBA;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,wBAAA;AAbF;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EACE,6BAAA;AAbF;;AAgBA;EACE,YAAA;EACA,0BAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAbF","sourcesContent":["ion-content {\n  --background: transparent !important;\n\n}\n\nion-grid {\n  --background: transparent !important;\n}\n\n.ask-customer-rotate-component-container {\n  // background: linear-gradient(to bottom, rgb(4, 19, 55) 30%, #01133b 50%, rgb(47, 103, 163) 98%, #182D72 100%) !important;\n  margin: 2px;\n  padding: 2px 10px 3px 10px;\n  // border-radius: 20px 0 20px 20px;\n  // border: 2px solid rgb(126, 156, 206);\n  // box-shadow: 0px 0px 4px 6px rgb(10, 3, 163);\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-top: 50px;\n}\n\n.ask-customer-rotate-close-button-container {\n  transform: translate(calc(var(--ask-customer-rotate-popover-width)/2 + 50px), 4px);\n  width: 38px;\n  background: rgb(4, 19, 55) !important;\n  border-radius: 10px 10px 0px 0px;\n  // border: 0 solid rgb(126, 156, 206);\n  border-width: 2px 2px 0 2px;\n  box-shadow: 0px -3px 3px 3px rgb(10, 3, 163);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n}\n\n.ask-customer-rotate-close-button {\n  cursor: pointer;\n  background: radial-gradient(circle at 50% 120%, #f20606, #e60404 10%, #7b0404 80%, #4c0202 100%);\n  height: 22px;\n  width: 22px;\n  border-radius: 11px;\n  box-shadow: 0 0px 5px 2px #ffffff,\n    0 0px 5px 6px rgb(10, 3, 163);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    text-shadow: 0 0px 5px rgb(0, 0, 0);\n    z-index: 3;\n    font-size: 0.8rem;\n  }\n}\n\n.sound-switch {\n  display: flex;\n  justify-content: center;\n  margin: 5px 0;\n}\n\nion-button[size*=medium] {\n  --border-radius: 7px;\n  height: 30px;\n  font-size: 14px;\n  width: 155px;\n}\n\nh3.description-text {\n  font-family: 'Mulish';\n  font-size: 20px;\n  color: white;\n  margin: 5px 0 0 0;\n  text-shadow: 2px 0px 0 #0d2e67,\n    -2px 0px 0 #0d2e67,\n    0px 2px 0 #0d2e67,\n    0px -2px 0 #0d2e67;\n  padding-left: 60px;\n  padding-right: 60px;\n\n  span {\n    color: white;\n    text-shadow: none;\n  }\n}\n\na.ask-customer-rotate-links {\n  cursor: pointer;\n  color: #86d2f0;\n  font-size: 9px;\n  font-weight: bold;\n  text-decoration: underline;\n  text-shadow: 1px 0 0 #000;\n  text-underline-offset: 3px;\n  text-decoration-color: #508be3;\n}\n\na.ask-customer-rotate-link-large {\n  font-size: 11px;\n}\n\np.ask-customer-rotate-version-text {\n  position: absolute;\n  bottom: 20px;\n  right: 8px;\n  left: unset;\n  text-orientation: mixed;\n  writing-mode: vertical-lr;\n  margin: 2px;\n  color: white;\n  font-size: 9px;\n  letter-spacing: 1px;\n}\n\n.ask-customer-rotate-spacer {\n  margin-top: 5px;\n}\n\n.rotate-picture {\n  width: 60%;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.ask-rotate-checkbox {\n  outline: 1px solid white;\n}\n\n.ask-customer-rotate-text {\n  color: white;\n}\n\n.ask-customer-rotate-checkbox-area {\n  padding-left: 60px !important;\n}\n\n.ask-customer-rotate-a-link {\n  color: white;\n  text-decoration: underline;\n}\n\n.right-bottom {\n  position: absolute;\n  bottom: 0;\n  right: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
